import { object, string } from 'yup';

import { getMaxLengthErrMsg } from '@constants/validationConstants';
import { MAX_DESCRIPTION_LENGTH } from '@constants/validationMessages';

export const validationSchema = object({
	comments: string()
		.trim()
		.default('')
		.max(MAX_DESCRIPTION_LENGTH, getMaxLengthErrMsg('Comments', MAX_DESCRIPTION_LENGTH)),
});
